import { render, staticRenderFns } from "./Exception.vue?vue&type=template&id=35a9d7f3&"
import script from "./Exception.vue?vue&type=script&lang=js&"
export * from "./Exception.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports